import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e52e0f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "float-sidebar" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"contact\" data-v-5e52e0f2><div class=\"requier\" data-v-5e52e0f2><i class=\"iconfont icon-qq\" data-v-5e52e0f2></i><div class=\"xkf_logo\" data-v-5e52e0f2><p data-v-5e52e0f2>QQ:785069855</p></div></div><div class=\"requier\" data-v-5e52e0f2><i class=\"iconfont icon-dianhuatianchong\" data-v-5e52e0f2></i><div class=\"xkf_logo\" style=\"top:50px;\" data-v-5e52e0f2><p data-v-5e52e0f2>电话:19952121879</p></div></div><div class=\"requier\" data-v-5e52e0f2><i class=\"iconfont icon-weixin\" data-v-5e52e0f2></i><div class=\"xkf_logo\" style=\"top:100px;\" data-v-5e52e0f2><p data-v-5e52e0f2>微信:19952121879</p></div></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangshangshouqi" }),
  /*#__PURE__*/_createTextVNode(" TOP ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_backtop, {
      bottom: 140,
      right: 20
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}